module.exports = __webpack_public_path__ + "img/custom-payment.c0d9491b.png";